export const getPage = (value: string) => {
  switch (value) {
    case 'DASHBOARD':
      return '/dashboard'
    case 'ALERTS':
      return '/alerts'
    case 'ACTIVITY':
      return '/activity'
    case 'DEVICES':
      return '/devices'
    case 'MEMBERS':
      return '/members'
    case 'INTEGRATIONS':
      return '/integrations'
    case 'BLOCKLIST':
      return '/blocklist'
    case 'ADVERSARIES':
      return '/adversaries'
    case 'SSO_ERROR':
      return '/sso-error'
    default:
      return '/dashboard'
  }
}
